import React from "react";
import ReactDOM from "react-dom";
import EPG from "../../EPG";
import "../../epg.scss";
import { EventsProvider } from "../../context/EventsContext";
import { getMake } from '../../../utils/models';
import HwFeatureService from "../../../services/HwFeatureService";
import ScreenService from "../../../services/ScreenService";
import WifiSetup from "../../../wifi-setup/WifiSetup";
import "../../../wifi-setup/WifiSetup.scss";

export function renderInteractiveUI(deeplinkEventId) {
    const hasEPGFF = window.__UpshowState && !!window.__UpshowState.settings.features.on_screen_menu;
    const make = getMake();
    const orgShouldCheckToSignTC = HwFeatureService.isSupported('should-sign-org-tc');
    const showMarketingButton = HwFeatureService.isSupported('epg-marketing-button');
    const showExitAppPopUp = HwFeatureService.isSupported('exit-comcast-app');
    const shouldApplyComcastStyles = HwFeatureService.isSupported('apply-comcast-styles');
    const hasWifiManagement = HwFeatureService.isSupported('wifi-management');

    ReactDOM.render(
        <>
            {/* WiFi Setup */}
            {hasWifiManagement && <WifiSetup />}

            {hasEPGFF && !ScreenService.isVertical && <div className={`epg ${make}`}>
                <EventsProvider>
                    <EPG deeplinkEventIdUrl={parseInt(deeplinkEventId)} orgShouldCheckToSignTC={orgShouldCheckToSignTC} showMarketingButton={showMarketingButton} showExitAppPopUp={showExitAppPopUp} shouldApplyComcastStyles={shouldApplyComcastStyles} />
                </EventsProvider>
            </div>}
        </>,
        document.getElementById("app-root")
    );
}
